import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import {CheckboxChangeEvent} from '@pluto/@types';
import {UserRolesEnum, UserStatusEnum} from '@pluto/users';
import {UserListFilters} from './UsersListTypes';

interface UserFiltersListProps {
    onRolesFilter: CheckboxChangeEvent;
    onStatusFilter: CheckboxChangeEvent;
    filters: UserListFilters;
}

export default function UserFiltersList(props: UserFiltersListProps) {
    const {
        onRolesFilter,
        onStatusFilter,
        filters,
    } = props;
    
    return (
        <Box className="users-list__filters">
            <FormControl
                component="div"
                className="users-list__filters__line"
            >
                <Typography variant="body1">Status:</Typography>
                <FormGroup className="users-list__filters__line__checkboxes">
                    <FormControlLabel
                        control={(
                            <Checkbox
                                name={UserStatusEnum.Active}
                                checked={filters.status?.includes(UserStatusEnum.Active)}
                            />
                        )}
                        label="Active"
                        onChange={onStatusFilter}
                    />
                    <FormControlLabel
                        control={(
                            <Checkbox
                                name={UserStatusEnum.Deactivated}
                                checked={filters.status?.includes(UserStatusEnum.Deactivated)}
                            />
                        )}
                        label="Deactivated"
                        onChange={onStatusFilter}
                    />
                    <FormControlLabel
                        control={(
                            <Checkbox
                                name={UserStatusEnum.Pending}
                                checked={filters.status?.includes(UserStatusEnum.Pending)}
                            />
                        )}
                        label="Pending"
                        onChange={onStatusFilter}
                    />
                </FormGroup>
            </FormControl>
            
            <FormControl
                component="div"
                className="users-list__filters__line"
            >
                <Typography variant="body1">Role:</Typography>
                <FormGroup className="users-list__filters__line__checkboxes">
                    <FormControlLabel
                        control={(
                            <Checkbox
                                name={UserRolesEnum.ContentOps}
                                checked={filters.roles?.includes(UserRolesEnum.ContentOps)}
                            />
                        )}
                        label="Content Operations Coordinator"
                        onChange={onRolesFilter}
                    />
                    <FormControlLabel
                        control={(
                            <Checkbox
                                name={UserRolesEnum.QCOperator}
                                checked={filters.roles?.includes(UserRolesEnum.QCOperator)}
                            />
                        )}
                        label="QC Operator"
                        onChange={onRolesFilter}
                    />
                    <FormControlLabel
                        control={(
                            <Checkbox
                                name={UserRolesEnum.Administrator}
                                checked={filters.roles?.includes(UserRolesEnum.Administrator)}
                            />
                        )}
                        label="Admin"
                        onChange={onRolesFilter}
                    />
                </FormGroup>
            </FormControl>
        </Box>
    );
}
